import { LOCK_ACTIONS, UNLOCK_ACTIONS, SHOW_OTP_MODAL, HIDE_OTP_MODAL } from "./actionTypes";

export const unlockActions = (unlockedUntil) => {
  localStorage.setItem("otpUnlockedUntil", unlockedUntil);
  return {
    type: UNLOCK_ACTIONS,
    payload: unlockedUntil,
  };
};

export const lockActions = () => {
  localStorage.removeItem("otpUnlockedUntil");
  return {
    type: LOCK_ACTIONS,
  };
};

export const showOtpModal = () => ({
  type: SHOW_OTP_MODAL,
});

export const hideOtpModal = () => ({
  type: HIDE_OTP_MODAL,
});
